import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import type { AnnuaireSanteProfessional } from '@aldebaran/common/types/structuredValue';
import { client } from '../util/client';

export const ANNUAIRE_SANTE_MIN_QUERY_CHARS = 3;

/** Debounced upstream by the caller; the server re-checks the 3-character floor. */
export const useAnnuaireSanteSearch = (query: string) => {
  const q = query.trim();
  return useQuery<AnnuaireSanteProfessional[], AxiosError>(
    ['annuaireSante', q],
    () =>
      client
        .get('/annuaireSante/search', { params: { q } })
        .then((res) => res.data),
    {
      enabled: q.length >= ANNUAIRE_SANTE_MIN_QUERY_CHARS,
      retry: 0, // a slow directory must surface as "indisponible", not a spinner
      staleTime: 5 * 60_000,
      // No keepPreviousData: a new text must never list the previous text's doctors.
      refetchOnWindowFocus: false,
    },
  );
};
